import type {
  AddExtraSalesItemToBookingItemApiData,
  AddExtraSalesItemToBookingItemApiResponses,
  BookingItemAvailableSalesItemOffersApiData,
  BookingItemAvailableSalesItemOffersApiResponses,
  BookingItemForPickupListApiData,
  BookingItemForPickupListApiResponses,
  BookingItemGetApiData,
  BookingItemGetApiResponses,
  BookingItemPatchApiData,
  BookingItemPatchApiResponses,
  SalesItemListAvailableForNewCarOnBookingApiData,
  SalesItemListAvailableForNewCarOnBookingApiResponses,
  ServiceFeedbackForWorkerListApiData,
  ServiceFeedbackForWorkerListApiResponses,
  WheelPickupSignedDocumentGetApiData,
  WheelPickupSignedDocumentGetApiResponses
} from '@navio/nsdk';

import type { ApiInput } from '../../utils';
import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

export const getBookingItemUrls = {
  getWheelPickupSignedPowersOfAttorney: dataEndpoint<
    WheelPickupSignedDocumentGetApiData,
    WheelPickupSignedDocumentGetApiResponses
  >({
    getUrl: ({ bookingItemId }) => apiUrl(`booking-items/${bookingItemId}/wheel-pickup-signed-power-of-attorney/`)
  }),
  getAvailableSalesItemOffersForBookingItem: dataEndpoint<
    BookingItemAvailableSalesItemOffersApiData,
    BookingItemAvailableSalesItemOffersApiResponses
  >({
    getUrl: ({ pk }) => apiUrl(`booking-items/${pk}/available-sales-item-offers/`)
  }),
  getSalesItemForNewCarInBooking: dataEndpoint<
    SalesItemListAvailableForNewCarOnBookingApiData,
    SalesItemListAvailableForNewCarOnBookingApiResponses
  >({
    getUrl: (queryParams) => apiUrl('sales-items/available-for-new-car-on-booking/', queryParams)
  }),
  getServiceWorkerFeedbacks: dataEndpoint<
    ServiceFeedbackForWorkerListApiData,
    ServiceFeedbackForWorkerListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('service-feedbacks/for-worker/', queryParams)
  }),
  postAddExtraSalesItemsToBookingItem: responseEndpoint<
    AddExtraSalesItemToBookingItemApiData,
    AddExtraSalesItemToBookingItemApiResponses
  >({
    getUrl: ({ bookingItemId }) => apiUrl(`booking-items/${bookingItemId}/add-extra-sales-items/`),
    getBody: (data) => data
  }),
  patchBookingItem: responseEndpoint<
    BookingItemPatchApiData,
    BookingItemPatchApiResponses,
    ApiInput<BookingItemPatchApiData> & { formData: FormData }
  >({
    getUrl: ({ bookingItemId }) => apiUrl(`booking-items/${bookingItemId}/`),
    getHeaders: () => ({
      'Content-Type': 'multipart/form-data'
    }),
    getBody: (args) => args.formData,
    skipBodyTransformation: true
  }),
  getPaginatedWheelStoragePickupBookingItems: dataEndpoint<
    BookingItemForPickupListApiData,
    BookingItemForPickupListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('booking-items/wheel-storage-pickups/', queryParams)
  }),
  getBookingItem: dataEndpoint<BookingItemGetApiData, BookingItemGetApiResponses>({
    getUrl: ({ bookingItemId }) => apiUrl(`booking-items/${bookingItemId}/`)
  })
};
